(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl-product-accordian-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.Accordion');

    accordions.forEach((accordion) => {
      const accordionTrigger = accordion.querySelector('.AccordionTrigger');
      const accordionContent = accordion.querySelector('.AccordionContent');

      // Apply ARIA and display values on load
      if (accordionTrigger.classList.contains('__active')) {
        accordionTrigger.setAttribute('aria-expanded', 'true');
        accordionContent.style.display = 'block';
        accordionContent.setAttribute('aria-hidden', 'false');
        accordionContent.style.height = `${accordionContent.scrollHeight}px`;
      } else {
        accordionTrigger.setAttribute('aria-expanded', 'false');
        accordionContent.style.display = 'none';
        accordionContent.setAttribute('aria-hidden', 'true');
      }

      // On click of accordion trigger
      accordionTrigger.addEventListener('click', (e) => {
        e.preventDefault();

        if (accordionTrigger.classList.contains('__active')) {
          closeAccordion(accordionTrigger, accordionContent);
        } else {
          openAccordion(accordionTrigger, accordionContent);

          // Close sibling accordions
          const siblingAccordions = Array.from(accordion.parentNode.querySelectorAll('.Accordion')).filter(
            (sibling) => {
              const siblingTrigger = sibling.querySelector('.AccordionTrigger');
              return (
                sibling !== accordion &&
                !sibling.classList.contains('AccordionManualClose') &&
                siblingTrigger &&
                siblingTrigger.getAttribute('aria-expanded') === 'true'
              );
            }
          );

          siblingAccordions.forEach((sibling) => {
            const siblingTrigger = sibling.querySelector('.AccordionTrigger');
            const siblingContent = sibling.querySelector('.AccordionContent');
            closeAccordion(siblingTrigger, siblingContent);
          });
        }
      });
    });

    // Slide down animation
    function openAccordion(trigger, content) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('__active');
      content.setAttribute('aria-hidden', 'false');
      content.style.display = 'block';

      const height = content.scrollHeight;
      content.style.height = '0';
      content.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        content.style.height = `${height}px`;
        content.style.opacity = '1';
      });

      content.addEventListener(
        'transitionend',
        () => {
          content.style.removeProperty('height');
          content.style.removeProperty('overflow');
          content.style.removeProperty('transition');
        },
        { once: true }
      );
    }

    // Slide up animation
    function closeAccordion(trigger, content) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('__active');
      content.setAttribute('aria-hidden', 'true');

      content.style.height = `${content.scrollHeight}px`;
      requestAnimationFrame(() => {
        content.style.height = '0';
        content.style.opacity = '0';
      });

      content.style.overflow = 'hidden';

      content.addEventListener(
        'transitionend',
        () => {
          content.style.display = 'none';
          content.style.removeProperty('height');
          content.style.removeProperty('overflow');
          content.style.removeProperty('transition');
        },
        { once: true }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
